import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/billing/financial-document/:documentId/receipt-description/`;

type QueryFnType = typeof queryFn;

type FinancialDocumentDescription = {
    public_description: string | null;
};

interface DTO {
    documentId: string;
    parkingId: string;
}
const queryFn = ({ documentId, parkingId }: DTO): Promise<FinancialDocumentDescription> => {
    return axios.get(formatResourcePath(RESOURCE, { documentId, parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetFinancialDocumentDescription, RESOURCE as GET_FINANCIAL_DOCUMENT_DESCRIPTION_RESOURCE };
